/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Medialibrarytooledit3Inputs */

const en_medialibrarytooledit3 = /** @type {(inputs: Medialibrarytooledit3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit`)
};

const de_medialibrarytooledit3 = /** @type {(inputs: Medialibrarytooledit3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bearbeitet`)
};

/**
* | output |
* | --- |
* | "Edit" |
*
* @param {Medialibrarytooledit3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const medialibrarytooledit3 = /** @type {((inputs?: Medialibrarytooledit3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Medialibrarytooledit3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_medialibrarytooledit3(inputs)
	return de_medialibrarytooledit3(inputs)
});
export { medialibrarytooledit3 as "mediaLibraryToolEdit" }